<div class="breadcrumb-area">
    <h1>Ejecución de Proceso Productivo</h1>
</div>
<div class="card mb-5">
    <div class="card-header">
        <h3>Ejecución de Proceso Productivo</h3>
    </div>
    <div class="card-body">
        <!-- <p class="text-muted">Una bodega se encuentra activa si el icono <i class="fa fa-power-off"></i> se encuentra
			en color <span style="font-weight: 900;color: green;">verde</span>. Activa o desactiva la bodega dando
			click sobre el icono antes mencionado.</p> -->

        <div class="row mb-4">
            <div class="col-6">
                <label for="product-order" class="form-label"
                    >Proceso Productivo</label
                >
                <div class="input-group bg-white rounded">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.processes"
                        [placeholder]="'Selecciona un proceso productivo'"
                        [filterElements]="processFilter"
                        (inputMethod)="writeProcess($event.event)"
                        (changeStatus)="checkProcess($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title = $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
            <div class="col-6">
                <label for="warehouse" class="form-label">Bodega de Salida</label>
                <div class="input-group bg-white rounded">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.warehouse"
                        [placeholder]="'Ingresa una bodega'"
                        [filterElements]="filterWarehouses"
                        (inputMethod)="writeWarehouse($event.event)"
                        (changeStatus)="checkWarehouse($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="currentProcess != null && currentWarehouse != null">
            <div class="col-sm-12" *ngIf="!loading">
                <h5 class="font-bold text-primary">Productos de Entrada</h5>
                <div class="table table-responsive mb-4 overflow-visible">
                    <table class="table" *ngIf="processDetails.length>0">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <!-- <th class="ta">Cantidad Necesaria</th> -->
                                <!-- <th>Medida</th> -->
                                <th>Bodega/Contenedor</th>
                                <!-- <th class="ta">Acciones</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of processDetailsIn; let i = index">
								<tr>
									<td  class="ta font-bold">
										{{item.productionProcessProduct.productData.name}}
									</td>
									<!-- <td  class="ta">
                                        {{item.productionProcessProduct.quantity}}
									</td> -->
                                    <!-- <td  class="ta">
										{{item.productionProcessProduct.quantity}}
									</td> -->
									<td class="row">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <ng-container *ngFor="let itemW of item.warehouseDetails; let j = index">
                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <app-process-warehouse
                                                                [productId]="item.productionProcessProduct.productId"
                                                                [detail]="itemW"
                                                                [principal]="itemW.principal"
                                                                [warehouseId]="currentWarehouse.id"
                                                                [process]="item.productionProcessProduct"
                                                            ></app-process-warehouse>
                                                        </div>
                                                        <div class="col-auto text-center d-flex justify-center items-center">
                                                            <span *ngIf="!itemW.principal" class="a-hover text-danger" (click)="removeDetailWarehouse(item, j)">
                                                                <i class="fa fa-trash"></i>
                                                            </span>
                                                        </div>
                                                    </div> 
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-between items-center">
                                            <div class="col-auto">
                                                <button class="btn btn-sm btn-link" (click)="addDetailWarehouse(item)">
                                                    <i class="fa fa-plus"></i> Agregar Bodega/Contenedor
                                                </button>
                                            </div>
                                            <div class="col-auto">
                                                <span>
                                                    Total: {{getTotalProduct(item)}}
                                                </span>
                                                <span class="text-danger" *ngIf="item.total<item.productionProcessProduct.quantity">
                                                    , Faltante: {{(item.productionProcessProduct.quantity - item.total).toFixed(6)}}
                                                </span>
                                                <span class="text-warning" *ngIf="item.total>item.productionProcessProduct.quantity">
                                                    , Excedido: {{(item.total - item.productionProcessProduct.quantity).toFixed(6)}}
                                                </span>
                                            </div>
                                        </div>
									</td>
                                    <!-- <td></td> -->
								</tr>
							</ng-container>
                            <ng-container *ngFor="let item of processDetailsInTemp; let i = index">
								<tr>
									<td  class="ta font-bold">
                                        <div class="d-flex flex-row items-center gap-2">
                                            <span class="a-hover text-danger" (click)="removeProductTemp(i)">
                                                <i class="fa fa-trash"></i>
                                            </span>
                                            <app-product-temp-process
                                                [(product)]="item.product"
                                            ></app-product-temp-process>
                                        </div>
									</td>
									<!-- <td  class="ta">
                                        {{item.productionProcessProduct.quantity}}
									</td> -->
                                    <!-- <td  class="ta">
										{{item.productionProcessProduct.quantity}}
									</td> -->
									<td class="row">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <ng-container *ngFor="let itemW of item.warehouseDetails; let j = index">
                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <span *ngIf="!item.product">Seleccione un producto</span>
                                                            <app-process-warehouse *ngIf="item.product"
                                                                [productId]="item.product.id"
                                                                [detail]="itemW"
                                                                [principal]="itemW.principal"
                                                                [warehouseId]="currentWarehouse.id"
                                                                [process]="item.productionProcessProduct"
                                                                [isTemp]="true"
                                                            ></app-process-warehouse>
                                                        </div>
                                                        <div class="col-auto text-center d-flex justify-center items-center">
                                                            <span *ngIf="!itemW.principal" class="a-hover text-danger" (click)="removeDetailWarehouse(item, j)">
                                                                <i class="fa fa-trash"></i>
                                                            </span>
                                                        </div>
                                                    </div> 
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-between items-center">
                                            <div class="col-auto">
                                                <button class="btn btn-sm btn-link" (click)="addDetailWarehouseTemp(item)" *ngIf="item.product">
                                                    <i class="fa fa-plus"></i> Agregar Bodega/Contenedor
                                                </button>
                                            </div>
                                            <div class="col-auto">
                                                <span>
                                                    Total: {{getTotalProduct(item)}}
                                                </span>
                                            </div>
                                        </div>
									</td>
                                    <!-- <td></td> -->
								</tr>
							</ng-container>
                            <tr>
                                <div class="d-flex justify-between items-center">
                                    <div class="col-auto">
                                        <button class="btn btn-sm btn-link" (click)="addProductTemp()">
                                            <i class="fa fa-plus"></i> Agregar Producto Extra
                                        </button>
                                    </div>
                                </div>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h5 class="font-bold text-primary">Productos de Salida</h5>
                <div class="table table-responsive overflow-visible">
                    <table class="table" *ngIf="processDetails.length>0">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <!-- <th class="text-center">%</th> -->
                                <!-- <th>Medida</th> -->
                                <th>Bodega/Contenedor</th>
                                <!-- <th class="ta">Acciones</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of processDetailsOut; let i = index">
								<tr>
									<td  class="ta font-bold">
										{{item.productionProcessProduct.productData.name}}
									</td>
									<!-- <td  class="text-center">
                                        {{item.productionProcessProduct.percentage}} %
									</td> -->
                                    <!-- <td  class="ta">
										{{item.productionProcessProduct.quantity}}
									</td> -->
									<td class="ta">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <ng-container *ngFor="let itemW of item.warehouseDetails; let j = index">
                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <app-process-warehouse
                                                                [productId]="item.productionProcessProduct.productId"
                                                                [detail]="itemW"
                                                                [principal]="itemW.principal"
                                                                [warehouseId]="currentWarehouse.id"
                                                                [isOut]="true"
                                                            ></app-process-warehouse>
                                                        </div>
                                                        <div class="col-auto text-center">
                                                            <span *ngIf="!itemW.principal" class="a-hover text-danger" (click)="removeDetailWarehouse(item, j)">
                                                                <i class="fa fa-trash"></i>
                                                            </span>
                                                        </div>
                                                    </div> 
                                                </ng-container>
                                            </div>
                                        </div>
                                        <!-- <button class="btn btn-sm btn-link" (click)="addDetailWarehouse(item)">
                                            <i class="fa fa-plus"></i> Agregar Bodega/Contenedor
                                        </button> -->
									</td>
                                    <!-- <td></td> -->
								</tr>
							</ng-container>
                        </tbody>
                    </table>
                </div>
                
                <div class="col-sm-12">
                    <span *ngIf="processDetails.length==0">
                        <i class="fa fa-circle-info"></i>
                        No existen Procesos Productivos registrados
                    </span>
                </div>
                <div class="col-sm-12"></div>
            </div>
            <div class="col-sm" *ngIf="loading">
                <app-loading-animation [height]="'3rem'" />
            </div>
        </div>
        <div class="row">
            <div class="d-flex flex-row justify-end">
                <app-loading-button
                    [object]="buttonExecute"
                    [disabled]="getDisabledSave()"
                    (clicked)="executeProcess()"
                />
            </div>
        </div>
    </div>
</div>
